import { QuestionnaireFormData } from '@/features/questionnaires/types/questionnaire.interface';
import { MenuItem } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SelectInput } from '@/shared';

export const DocumentQuestionParameters = ({
  questionIndex,
}: {
  questionIndex: number;
}) => {
  const { t } = useTranslation();
  const form = useFormContext<QuestionnaireFormData>();

  return (
    <SelectInput
      form={form}
      name={`questions.${questionIndex}.parameters.documentType`}
      label={t('pages.studies.questions.documentType.label')}
      required
    >
      <MenuItem value="FILE">
        {t('pages.studies.questions.documentType.file')}
      </MenuItem>
      <MenuItem value="IMAGE">
        {t('pages.studies.questions.documentType.image')}
      </MenuItem>
      <MenuItem value="VIDEO">
        {t('pages.studies.questions.documentType.video')}
      </MenuItem>
    </SelectInput>
  );
};
